import React from 'react';
import Link from 'next/link';
import { format } from 'date-fns';

import { firebase } from '@app/config/fire-conf';
import Image from '@app/components/image';

import { MovieCardStyled, MoviePosterStyled, ComingSoonTextStyled } from './movie-card-styled';

type MovieCardProps = {
  slug: string;
  movieName: string;
  poster?: string;
  trailer?: string;
  certification?: string;
  releaseDate: firebase.firestore.Timestamp;
  premiereDate?: firebase.firestore.Timestamp | false;
  runTime?: number;
  status?: string;
  isSlider?: boolean;
  cinema?: string;
  onWatchTrailer: (url: string) => void;
};

const MovieCard = ({
  movieName,
  poster = '',
  trailer = '',
  certification = '',
  releaseDate,
  premiereDate,
  status = '',
  isSlider = false,
  runTime,
  onWatchTrailer,
  slug,
  cinema,
}: MovieCardProps): JSX.Element => {
  return (
    <MovieCardStyled isSlider={isSlider}>
      <div className="movie-poster">
        <Link href={`/movie/${slug}/`}>
          <a className="movie-poster-link"> </a>
        </Link>
        <MoviePosterStyled>
          <Image
            src={poster}
            layout="fill"
            objectFit="contain"
            loading="eager"
            alt={`${movieName} poster`}
          />
        </MoviePosterStyled>
      </div>
      <section>
        <h4>
          <Link href={`/movie/${slug}/`}>{movieName}</Link>
        </h4>
      </section>
      <ul>
        <li>{format(new Date(releaseDate.toDate()), 'yyyy')}</li>
        <li>{certification && <span>{certification}</span>}</li>
        {runTime !== undefined && runTime !== 0 && (
          <li>{`${Math.floor(runTime / 60)}h ${runTime % 60}m`}</li>
        )}
      </ul>
      {premiereDate && status === 'coming-soon' && (
        <ComingSoonTextStyled>
          <div>
            <span>From {`${format(premiereDate.toDate(), "do 'of' LLLL")}`}</span>
          </div>
        </ComingSoonTextStyled>
      )}
      <div className="button-groupe">
        {status === 'active' && (
          <Link
            href={
              cinema ? `/buy-tickets?movie=${slug}&cinema=${cinema}` : `/buy-tickets?movie=${slug}`
            }>
            <a className="btn btn--primary outline-none">Buy tickets</a>
          </Link>
        )}
        <button
          type="button"
          className="btn btn--secondary-outline outline-none"
          onClick={() => onWatchTrailer(trailer)}>
          Watch trailer
        </button>
      </div>
    </MovieCardStyled>
  );
};

export default MovieCard;
